import { render } from "./boneTenYears.vue?vue&type=template&id=472a00e1&scoped=true"
import script from "./boneTenYears.vue?vue&type=script&lang=ts"
export * from "./boneTenYears.vue?vue&type=script&lang=ts"

import "./boneTenYears.vue?vue&type=style&index=0&id=472a00e1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-472a00e1"

export default script